module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/author#author"
    }
  }, [_c('strong', [_vm._v("AUTHOR’S NOTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#ch01"
    }
  }, [_c('strong', [_vm._v("MONEY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("DRUGS "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" ALCOHOL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INSULTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CARS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SEX "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" RELATIONSHIPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CRIME "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" WEAPONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("FASHION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SKILLS "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" PRIDE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PEOPLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PLACES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0